module.exports = __webpack_public_path__ + "img/8.e31ef5e1.jpg";